<template>
    <div class="card">
        <div class="card-header border-bottom">
            <i class="fas fa-cog me-2"></i>{{ TR.system_page_header }}
        </div>
        <div class="card-body container p-3">
            <div v-if="G.userHavePermission('add')" class="row mb-3">
                <div class="col-12 col-sm-8 offset-sm-2">

                    <fieldset class="p-3 mb-3 text-primary border-bottom border-primary border-2">
                        <legend class="fw-bold mb-3 border-bottom">{{ TR.add }}</legend>
                        <Tabs value="0">
                            <TabList>
                                <Tab value="0">
                                    <i class="fas fa-list me-2"></i>
                                    {{TR.text}}
                                </Tab>
                                <Tab value="1">
                                    <i class="fas fa-file-alt me-2"></i>
                                    {{TR.file}}
                                </Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel value="0">
                                    <!-- <template #header>
                                        <i class="fas fa-list me-2"></i>
                                        {{TR.text}}
                                    </template> -->

                                    <div class="row my-3 d-flex">
                                        <div class="col-12 col-sm-4 mb-3 mb-sm-0">
                                            <label>{{TR.key}}</label>
                                            <!-- <input type="text" class="p-inputtext p-component p-filled" v-model="new_data['key']" /> -->
                                            <InputText
                                                v-model="new_data['key']"
                                            />
                                        </div>
                                        <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                                            <label>{{TR.value}}</label>
                                            <!-- <input type="text" class="p-inputtext p-component p-filled" v-model="new_data['value']" /> -->
                                            <InputText
                                                v-model="new_data['value']"
                                            />
                                        </div>
                                        <div class="col-12 col-sm-2 mb-3 mb-sm-0 align-self-end">
                                            <button v-if="G.userHavePermission('add')" class="btn btn-primary" @click="addSystemKeyValue"><i class="fas fa-plus me-2"></i>{{ TR.add }}</button>
                                        </div>
                                    </div>
                                </TabPanel>

                                <TabPanel value="1">
                                    <!-- <template #header>
                                        <i class="fas fa-file-alt me-2"></i>
                                        {{TR.file}}
                                    </template> -->

                                    <div class="row my-3 d-flex">
                                        <div class="col-12 col-sm-4 mb-3 mb-sm-0">
                                            <label>{{TR.key}}</label>
                                            <!-- <input type="text" class="p-inputtext p-component p-filled" v-model="new_data['key']" /> -->
                                            <InputText
                                                v-model="new_data['key']"
                                            />
                                        </div>
                                        <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                                            <label>{{TR.value}}</label>
                                            <!-- <input type="text" class="form-control" v-model="new_data['file_value']" /> -->
                                            <InputFile :placeholder="TR.select_file" v-model="new_data['file_value']" accept="image/png,image/jpeg" />
                                        </div>
                                        <div class="col-12 col-sm-2 mb-3 mb-sm-0 align-self-end">
                                            <button v-if="G.userHavePermission('add')" class="btn btn-primary" @click="addSystemFileKeyValue"><i class="fas fa-plus me-2"></i>{{ TR.add }}</button>
                                        </div>
                                    </div>
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </fieldset>

                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-8 offset-sm-2">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>{{TR.name}}</th>
                                <th colspan="2">{{TR.value}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in sdata" :key="index">
                                <td>{{ TR[index] }} <span class="ms-2 text-muted small">( {{ index }} )</span> </td>
                                <td>
                                    <div class="d-flex w-full">
                                        <!-- <img v-if="item.type == 'file' && item.value != ''" :src="item.value" class="me-2 rounded" style="width: 1.8rem;" /> -->
                                        <Image
                                            v-if="item.type == 'file' && item.value != ''"
                                            :src="item.value"
                                            :alt="TR.image"
                                            :preview="true"
                                            class="me-2"
                                            height="34"
                                        />
                                        <InputFile v-if="item.type == 'file'" :placeholder="TR.select_file" v-model="file_data[index]" accept="image/png,image/jpeg" @select="(e) => {item.value = file_data[index][0]?.objectPath;}" />

                                        <!-- <select v-else-if="index == 'timezone' && sdata.timezone" v-model="sdata.timezone.value" class="form-control">
                                            <template v-for="(item, index) in tzlist" :key="index">
                                                <option :value="item.value">{{ item.label }}</option>
                                            </template>
                                        </select> -->

                                        <Select
                                            v-else-if="index == 'timezone' && sdata.timezone && tzlist.length"
                                            v-model="sdata.timezone.value"
                                            :options="tzlist"
                                            optionValue="value"
                                            optionLabel="label"
                                            :placeholder="item.placeholder || TR.select"
                                            class="p-column-filter w-100"
                                            :filter="true"
                                            :showClear="false"
                                        >
                                            <template #value="slotProps">
                                                <div v-if="slotProps.value">
                                                    {{tzlist.filter((e) => e.value == slotProps.value)[0].label}}
                                                </div>
                                                <span v-else>{{slotProps.placeholder}}</span>
                                            </template>
                                            <template #option="slotProps">
                                                <div>{{slotProps.option.label}}</div>
                                            </template>
                                        </Select>

                                        <!-- <input v-else type="text" class="p-inputtext p-component p-filled me-2" v-model="sdata[index].value" /> -->
                                        <InputText
                                            v-else
                                            v-model="sdata[index].value"
                                        />
                                    </div>
                                </td>
                                <td>
                                    <button v-if="G.userHavePermission('remove')" class="btn btn-danger" @click="removeByKey(index)"><i class="fas fa-trash"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer container border-01">
            <div class="row">
                <div class="col-12 col-sm-8 offset-sm-2">
                    <button v-if="G.userHavePermission('update')" class="btn btn-primary" @click="saveSystemSettings">
                        <i class="fas fa-save me-2"></i>
                        {{ TR.save }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watchEffect } from 'vue';

import { useStore } from "@/store";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Image from 'primevue/image';
import InputText from 'primevue/inputtext';

import moment from 'moment-timezone';

import {G, ajax} from '@/_common';
import InputFile from '@/components/field/InputFile';
import Select from "primevue/select";

export default {
    name: 'SystemP',
    title: 'system',
    components:{
        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,
        InputFile,
        Select,
        Image,
        InputText,
    },
    setup() {
        const store = useStore();

        const sdata = ref({});
        const TR = ref({});

        const new_data = ref({
            "key": '',
            "value": '',
            "file_value": '',
        });
        const file_data = ref({});

        // const getSystemSettingsData = async () => {
        //     await ajax({
        //         url: store.getSystemSettings('system'),
        //         // method: route.params.id !== undefined ? 'patch' : 'post',
        //         // content_type: 'application/json; charset=UTF-8',
        //         success: async (x) => {
        //             let res = x.data || null;
        //             if ( x.status == 200 && res ) {
        //                 sdata.value = res;
        //                 for(let a in res){
        //                     G.systemData[a] = {"value": res[a].value, "type": res[a].type};
        //                 }
        //             }
        //             else{
        //                 G.alert.error(res.detail);
        //             }
        //         },
        //     });
        // };

        const tzlist = moment.tz.names().map((key) => {
            return { value: key, label: key + " (" + moment.tz(key).format('Z') + ")" }
        });

        watchEffect(() => {
            TR.value = store.getTranslation();
            sdata.value = G.systemData;
        });

        // onBeforeMount(async () => {
        //     // console.log(G.systemData.company);
        //     // if( G.systemData.company === undefined ){
        //     //     getSystemSettingsData();
        //     // }
        //     // else{
        //     //     sdata.value = G.systemData;
        //     // }
        // });

        const addSystemKeyValue = async () => {
            let key = new_data.value['key'], val = new_data.value['value'];
            if( G.userHavePermission('add') && key !== undefined && key != '' && val !== undefined && val != '' ){
                if( sdata.value[key] === undefined )
                {
                    await ajax({
                        url: store.getSystemSettingsKey('system'),
                        method: 'post',
                        content_type: 'application/json; charset=UTF-8',
                        data: {
                            data_index: key,
                            data_value: val
                        },
                        success: (e) => {
                            new_data.value = {
                                "key": '',
                                "value": '',
                                "file_value": '',
                            };
                            G.alert.success(TR.value.msg_add_success);

                            sdata.value = e.data;

                            for(let a in sdata.value){
                                G.systemData[a] = {"value": sdata.value[a].value, "type": sdata.value[a].type};
                            }
                            // getSystemSettingsData();
                        }
                    });
                }
                else{
                    G.alert.warning(TR.value.already_exists);
                }
            }
        };

        const addSystemFileKeyValue = async () => {
            let key = new_data.value['key'], val = new_data.value['file_value'];
            if( G.userHavePermission('update') && key !== undefined && key != '' && val !== undefined && val != '' ){
                if( sdata.value[key] === undefined )
                {
                    let formData = new FormData();
                    if( key != '' && typeof val === 'object' ){
                        formData.append("upload_image", val[0]);
                    }

                    let sysData = {
                        "data_index": key,
                        "data_value": val[0].name
                    };

                    formData.append("data", JSON.stringify(sysData));

                    await ajax({
                        url: store.getSystemSettingsFile('system'),
                        method: 'post',
                        // content_type: 'application/json; charset=UTF-8',
                        data: formData,
                        success: (e) => {
                            new_data.value = {
                                "key": '',
                                "value": '',
                                "file_value": '',
                            };
                            G.alert.success(TR.value.msg_add_success);

                            sdata.value = e.data;

                            for(let a in sdata.value){
                                G.systemData[a] = {"value": sdata.value[a].value, "type": sdata.value[a].type};
                            }
                            // getSystemSettingsData();
                        }
                    });
                }
                else{
                    G.alert.warning(TR.value.already_exists);
                }
            }
        };

        const removeByKey = (key) => {
            if( G.userHavePermission('remove') ){
                G.alert.confirm({
                    title: TR.value.warning,
                    msg: TR.value.msg_remove_question,
                    yesTitle: TR.value.yes,
                    yes: async () => {
                        delete sdata.value[key];

                        await ajax({
                            url: store.getSystemSettings('system'),
                            method: 'delete',
                            content_type: 'application/json; charset=UTF-8',
                            data: {
                                data_index: key
                            },
                            success: (e) => {
                                sdata.value = e.data;
                                for(let a in sdata.value){
                                    G.systemData[a] = {"value": sdata.value[a].value, "type": sdata.value[a].type};
                                }
                                G.alert.success(TR.value.msg_remove_success);
                            }
                        });
                    },
                    noTitle: TR.value.no, no: () => {}
                });
            }
        };

        const saveSystemSettings = async () => {
            if( G.userHavePermission('update') )
            {
                let type, val, kvPair = {}, formData = new FormData();

                for(let a in sdata.value){
                    type = sdata.value[a]['type'], val = sdata.value[a]['value'];
                    if( a != '' && type == 'file' && typeof file_data.value[a] === 'object' ){
                        formData.append("upload_image", file_data.value[a][0]);
                    }
                    kvPair[a] = {
                        "type": type,
                        "value": ( a != '' && type == 'file' && typeof file_data.value[a] === 'object' ) ? file_data.value[a][0].name : val
                    };
                }

                formData.append("data", JSON.stringify({
                    "data_index": 'updateall',
                    "data_value": JSON.stringify(kvPair)
                }));

                await ajax({
                    url: store.getUpdateSystemSettingsAll('system'),
                    method: 'patch',
                    data: formData,
                    // content_type: 'application/json; charset=UTF-8',
                    // data: JSON.stringify(sdata.value),
                    success: async (x) => {
                        let res = x.data || null;
                        if ( x.status == 200 && res ) {
                            sdata.value = res;
                            for(let a in res){
                                G.systemData[a] = {"value": res[a].value, "type": res[a].type};
                            }
                            G.alert.success( TR.value.msg_success );
                        }
                        else{
                            G.alert.error(TR.value.msg_error);
                        }
                        new_data.value = {
                            "key": '',
                            "value": '',
                            "file_value": '',
                        };
                        file_data.value = {};
                    },
                });
            }
        };

        return {
            TR,
            G,
            sdata,
            addSystemKeyValue,
            addSystemFileKeyValue,
            saveSystemSettings,
            removeByKey,
            new_data,
            file_data,
            tzlist,
        };
    },
}
</script>